<template>
  <div class="text-white text-sm gap-6 flex flex-col">
    <div v-if="showPreview" class="bg-black rounded-2xl border border-[#424242] p-6">
      <div class="flex justify-between items-start">
        <div class="text-md font-normal">
          <div class="mb-3">{{ selectedDate.format('DD MMMM YYYY') }}, {{ selectedTime.format('HH:mm') }}, ({{ selectedGender }})</div>
          <div>{{ locationName }}</div>
        </div>
        <OButton pure class="w-10 h-10 u-center bg-[#181819] rounded-full" @click="showPreview = false">
          <OIcon icon="edit-white" class="w-6 h-6" />
        </OButton>
      </div>
    </div>
    <div v-else class="bg-black rounded-2xl border border-[#424242] p-6">
      <div class="w-full flex flex-col sm:flex-row gap-6">
        <!-- birthdate -->
        <div class="w-full">
          <div class="mb-1.5">Doğum Tarihi</div>

          <div class="rising-sign-date-dropdown-wrapper w-full">
            <OButton
              pure
              class="dropdown-toggle w-full h-12 bg-[#181819] rounded-lg px-4 flex items-center justify-between text-md"
              :class="{ 'text-gray-400': !selectedDate }"
              @click="toggleMonthDropdown"
            >
              {{ selectedDate ? selectedDate.format('DD MMMM YYYY') : 'Gün Ay Yıl' }}
              <OIcon icon="chevron-left-white" class="-rotate-90 w-4 h-4" />
            </OButton>
            <div v-if="showBirthdayDropdown" class="dropdown-list dropdown-list-date">
              <OCalendar :date="selectedDate" :min-date="minDate" :max-date="maxDate" @select="handleDateSelect" />
            </div>
          </div>
        </div>
        <!-- birth time -->
        <div class="w-full">
          <div class="mb-1.5">Doğum Saati</div>
          <div class="rising-sign-time-dropdown-wrapper w-full">
            <OButton
              pure
              class="dropdown-toggle w-full h-12 bg-[#181819] rounded-lg px-4 flex items-center justify-between text-md"
              :class="{ 'text-gray-400': !selectedTime }"
              @click="toggleTimeDropdown"
            >
              {{ selectedTime ? selectedTime.format('HH:mm') : 'Saat ve Dakika' }}
              <OIcon icon="chevron-left-white" class="-rotate-90 w-4 h-4" />
            </OButton>
            <div v-if="showTimeDropdown" class="dropdown-list dropdown-list-time">
              <OTimePicker :time="selectedTime" @select="handleTimeSelect" />
            </div>
          </div>
        </div>
        <!-- gender -->
        <div class="w-full">
          <div class="mb-1.5">Cinsiyet</div>
          <div class="rising-sign-gender-dropdown-wrapper w-full">
            <OButton
              pure
              class="dropdown-toggle w-full h-12 bg-[#181819] rounded-lg px-4 flex items-center justify-between text-md"
              :class="{ 'text-gray-400': !selectedGender }"
              @click="toggleGenderDropdown"
            >
              {{ selectedGender ? selectedGender : 'Cinsiyet' }}
              <OIcon icon="chevron-left-white" class="-rotate-90 w-4 h-4" />
            </OButton>
            <div v-if="showGenderDropdown" class="dropdown-list dropdown-list-gender">
              <OButton pure class="dropdown-item w-full" @click="handleGenderSelect('Erkek')">Erkek</OButton>
              <OButton pure class="dropdown-item w-full" @click="handleGenderSelect('Kadın')">Kadın</OButton>
            </div>
          </div>
        </div>
      </div>

      <!-- birth location -->
      <div class="mt-6 mb-1.5">Doğum Yeri</div>
      <div class="rising-sign-location-dropdown-wrapper w-full relative">
        <div class="w-full h-12 bg-[#181819] rounded-lg pr-4 flex items-center justify-between text-md">
          <input
            v-model="locationText"
            type="text"
            class="w-full h-12 bg-[#181819] rounded-lg px-4 text-md outline-none placeholder-gray-400"
            placeholder="Şehir ara"
            @input="handleLocationInput"
          />
          <OIcon icon="chevron-left-white" class="-rotate-90 w-4 h-4" />
        </div>
        <div v-if="showLocationDropdown" class="dropdown-list dropdown-list-location absolute top-14 right-0 left-0 h-48">
          <div v-if="loading" class="flex-col absolute inset-0">
            <div v-for="index in range(0, 4)" :key="index" class="dropdown-item flex items-center w-full">
              <OIcon icon="location-white" class="mr-2 w-4 h-4" />
              <div class="w-full h-[20px] bg-gray-200 opacity-5 rounded-lg"></div>
            </div>
          </div>
          <div v-for="(result, index) in locationResult" :key="index">
            <div class="dropdown-item flex items-center" @click="handleLocationSelect(result)">
              <OIcon icon="location-white" class="mr-2 w-4 h-4" />
              {{ result.display_name }}
            </div>
          </div>
          <div v-if="locationResult.length === 0 && loading !== true" class="flex u-center w-full h-full">
            <div class="w-full h-[20px] rounded-lg text-center text-sm text-white">Sonuç bulunamadı</div>
          </div>
        </div>
      </div>
      <div class="mt-1.5 text-sm text-[#E2E5ED]">Kesin sonuçlar için en doğru konum ve coğrafi koordinatlar önerilir.</div>
    </div>
    <!-- buttons -->
    <div v-if="!showPreview" class="flex items-center gap-3">
      <OButton pure class="w-full h-12 bg-[#181819] u-center rounded-full text-lg font-semibold" @click="handleClear">Temizle</OButton>
      <OButton
        pure
        class="w-full h-12 bg-[#6842EF] u-center rounded-full text-lg font-semibold"
        :disabled="!selectedDate || !selectedTime || !selectedLocation || !selectedGender"
        :class="{ 'opacity-50 cursor-not-allowed': !selectedDate || !selectedTime || !selectedLocation || !selectedGender }"
        @click="handleCalculate"
      >
        {{ isResultPage ? 'Yeniden Hesapla' : isNatalChart ? 'Haritayı Göster' : 'Yükselen Hesapla' }}
      </OButton>
    </div>
  </div>
</template>

<script>
import { defineComponent, useRoute, ref, onMounted, onBeforeUnmount, useContext } from '@nuxtjs/composition-api';
import { OButton, OIcon, OCalendar, OTimePicker } from '@/modules/common/components/ui';
import { debounce, range } from 'lodash';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { encodeQuery } from '~/modules/common/utils/routingUtils';
dayjs.extend(customParseFormat);
dayjs.locale('tr');

export default defineComponent({
  components: {
    OButton,
    OIcon,
    OCalendar,
    OTimePicker,
  },
  props: {
    isNatalChart: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { $service, $error } = useContext();
    // route
    const route = useRoute();
    const date = route.value.query?.date;
    const time = route.value.query?.time;
    const location = route.value.query?.location;
    const gender = route.value.query?.gender;
    const locationName = route.value.query?.locationName;
    const isResultPage = route.value.path.includes('/sonuc');
    const showPreview = ref(isResultPage);
    const loading = ref(false);
    // date
    const selectedDate = ref(date ? dayjs(date, 'DD-MM-YYYY') : null);
    const minDate = ref('1925-01-01');
    const maxDate = ref('2025-12-31');
    // time
    const selectedTime = ref(time ? dayjs().hour(time.split(':')[0]).minute(time.split(':')[1]).second(0).millisecond(0) : null);
    // gender
    const selectedGender = ref(gender || null);
    // location
    const showLocationDropdown = ref(false);
    const locationText = ref(locationName || '');
    const locationResult = ref(null);
    const selectedLocation = ref(
      location
        ? {
            lat: location.split('-')[0],
            lon: location.split('-')[1],
            display_name: locationName,
          }
        : null
    );

    const handleDateSelect = (date) => {
      selectedDate.value = date;
      showBirthdayDropdown.value = false;
    };

    const showBirthdayDropdown = ref(false);
    const toggleMonthDropdown = () => {
      showBirthdayDropdown.value = !showBirthdayDropdown.value;
    };

    const handleTimeSelect = (time) => {
      selectedTime.value = time;
      showTimeDropdown.value = false;
    };

    const showTimeDropdown = ref(false);
    const toggleTimeDropdown = () => {
      showTimeDropdown.value = !showTimeDropdown.value;
    };

    const showGenderDropdown = ref(false);
    const toggleGenderDropdown = () => {
      showGenderDropdown.value = !showGenderDropdown.value;
    };

    const handleGenderSelect = (gender) => {
      selectedGender.value = gender;
      showGenderDropdown.value = false;
    };

    const handleLocationInput = debounce(async (e) => {
      locationText.value = e.target.value;
      if (locationText.value.length < 3) {
        showLocationDropdown.value = false;
        return;
      }
      loading.value = true;
      locationResult.value = [];
      showLocationDropdown.value = true;
      try {
        const data = await $service.search.searchLocation({ city: locationText.value });
        locationResult.value = data;
      } catch (error) {
        $error(error);
      } finally {
        loading.value = false;
      }
    }, 1000);

    const handleLocationSelect = (result) => {
      locationText.value = result.display_name;
      selectedLocation.value = result;
      showLocationDropdown.value = false;
    };

    // close dropdowns
    const closeDropdown = (e) => {
      if (!e.target.closest('.rising-sign-date-dropdown-wrapper') && !e.target.closest('.dropdown-item')) {
        showBirthdayDropdown.value = false;
      }
      if (!e.target.closest('.rising-sign-time-dropdown-wrapper') && !e.target.closest('.dropdown-item')) {
        showTimeDropdown.value = false;
      }
      if (!e.target.closest('.rising-sign-gender-dropdown-wrapper') && !e.target.closest('.dropdown-item')) {
        showGenderDropdown.value = false;
      }
      if (!e.target.closest('.rising-sign-location-dropdown-wrapper')) {
        showLocationDropdown.value = false;
      }
    };

    // close dropdown when clicking outside
    onMounted(() => {
      window.addEventListener('click', closeDropdown);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('click', closeDropdown);
    });

    const handleCalculate = () => {
      if (!selectedDate.value || !selectedTime.value || !selectedLocation.value || !selectedGender.value) {
        return;
      }

      const queryParams = encodeQuery({
        date: selectedDate.value.format('DD-MM-YYYY'),
        time: selectedTime.value.format('HH:mm'),
        location: selectedLocation.value.lat + '-' + selectedLocation.value.lon,
        locationName: selectedLocation.value.display_name,
        gender: selectedGender.value,
      });
      const path = props.isNatalChart ? '/astroloji/dogum-haritasi-hesaplama/sonuc' : '/astroloji/yukselen-burc-hesaplama/sonuc';
      document.location.href = `${path}${queryParams}`;
      setTimeout(() => {
        handleClear();
      }, 500);
    };

    const handleClear = () => {
      selectedDate.value = null;
      selectedTime.value = null;
      selectedLocation.value = null;
      selectedGender.value = null;
      locationText.value = '';
      locationResult.value = null;
    };

    return {
      locationName,
      isResultPage,
      showPreview,
      handleCalculate,
      handleClear,
      // date
      selectedDate,
      minDate,
      maxDate,
      handleDateSelect,
      showBirthdayDropdown,
      toggleMonthDropdown,
      // time
      selectedTime,
      handleTimeSelect,
      showTimeDropdown,
      toggleTimeDropdown,
      // gender
      selectedGender,
      showGenderDropdown,
      handleGenderSelect,
      toggleGenderDropdown,
      // location
      showLocationDropdown,
      locationText,
      locationResult,
      selectedLocation,
      handleLocationInput,
      handleLocationSelect,
      loading,
      range,
    };
  },
});
</script>

<style scoped lang="scss">
.rising-sign-date-dropdown-wrapper,
.rising-sign-time-dropdown-wrapper,
.rising-sign-gender-dropdown-wrapper {
  position: relative;
}
.dropdown-toggle {
  background: #19191a;
  cursor: pointer;
  user-select: none;
}
.dropdown-list {
  position: absolute;
  overflow: hidden;
  top: 110%;
  left: 0;
  right: 0;
  background: #000;
  border-radius: 8px;
  border: 1px solid #424242;
  z-index: 10;
  height: 320px;
  overflow-y: auto;
}
.dropdown-list-date {
  min-width: 304px;
  height: 350px;
}
.dropdown-list-time {
  width: 152px;
  overflow-y: hidden;
}
.dropdown-list-gender {
  width: 152px;
  height: 76px;
  overflow-y: hidden;
}
.dropdown-list-location {
  width: 100%;
  @include sm {
    width: 330px;
  }
  height: 148px;
  background: #181819;
  overflow-y: auto;
}
.dropdown-item {
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  cursor: pointer;
  transition: background 0.2s;
  border-bottom: 1px solid #424242;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
}
.dropdown-item.selected,
.dropdown-item:hover {
  background: #6842ef;
}
</style>
